import React from 'react';

interface TerminologyInlineProps {
    term: string;
    label?: string;
    onSelect?: (term: string) => void;
    className?: string;
}

/**
 * A reusable component that provides a contextual lookup link for professional terminology.
 * When clicked, it should trigger the opening of the Glossary Drawer with the specific term selected.
 */
export const TerminologyInline: React.FC<TerminologyInlineProps> = ({ 
    term, 
    label, 
    onSelect,
    className = ""
}) => {
    return (
        <span 
            onClick={(e) => {
                e.stopPropagation();
                onSelect?.(term);
            }}
            className={`
                cursor-help 
                border-b border-dotted border-blue-400/60 
                hover:border-blue-400 hover:text-blue-400 
                transition-all duration-200 
                ${className}
            `}
            title={`Click to view definition for: ${term}`}
        >
            {label || term}
        </span>
    );
};

export default TerminologyInline;
